"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cartReducer = void 0;
const local_storage_1 = require("local-storage");
const monet_1 = require("monet");
const ts_pattern_1 = require("ts-pattern");
const select_1 = require("../redux/select");
const lenses_1 = require("./lenses");
const cartReducer = (state) => (action) => (0, ts_pattern_1.match)(action)
    .with({ type: 'SET_CART' }, _action => {
    const newState = lenses_1.cartValueLens.set(_action.payload)(state);
    const cartQuantity = (0, select_1.selectCartCount)(newState);
    (0, local_storage_1.set)('cart_quantity', cartQuantity);
    return newState;
})
    .with({ type: 'SET_CART_ERROR' }, _action => lenses_1.cartErrorLens.set(_action.payload)(state))
    .with({ type: 'CLEAR_CART_ERROR' }, _action => lenses_1.cartErrorLens.set((0, monet_1.None)())(state))
    .with({ type: 'SET_CART_LOADING' }, _action => lenses_1.cartLoadingLens.set(_action.payload)(state))
    .exhaustive();
exports.cartReducer = cartReducer;
//# sourceMappingURL=reducer.js.map